import React from 'react';
import Load from '../../../../models/load';
import Status from '../../../../models/status';
import classes from './LoadItem.module.scss';
import { Col, Row } from 'reactstrap';
import { FaExclamationTriangle } from 'react-icons/fa';

interface LoadItemProps {
  statuses: {
    statuses: Status[]
    isLoading: boolean
  }
  refresh: () => void
  key: string
  shade: 'even' | 'odd'
  load: Load
  selected: boolean
  select: (load: Load) => void
  invalidContainerChecksum?: boolean
};

const LoadItem: React.FC<LoadItemProps> = (props) => {
  return (
    <>
      <Row
        onClick={() => props.select(props.load)}
        className={[
          classes[props.shade],
          'd-flex',
          classes['load-item'],
          'g-0',
          'py-2',
          props.selected ? classes['selected'] : '',
          props.invalidContainerChecksum ? classes['invalid-container-checksum'] : ''
        ].filter(Boolean).join(' ')}>
        <Col className={[classes['equal-width-columns']].join(' ')}>
          <div className={classes['date-cell']}>
            {
              props.load.loadDate !== '' &&
              props.load.loadDate != null ?
              new Date(props.load.loadDate).toDateString() : null
            }
            {props.invalidContainerChecksum && (
              <span className={classes['invalid-checksum-badge']} title="Container number check digit failed (ISO 6346)">
                <FaExclamationTriangle className={classes['invalid-checksum-badge-icon']} aria-hidden />
                Invalid container number
              </span>
            )}
          </div>
        </Col>

        <Col className={[classes['hide-tablet'], classes['equal-width-columns']].join(' ')}>
          <div>{props.load.loadPoint1}</div>
        </Col>

        <Col className={[classes['hide-tablet'], classes['equal-width-columns']].join(' ')}>
          <div>{props.load.loadPoint2}</div>
        </Col>

        <Col className={[classes['hide-tablet'], classes['equal-width-columns']].join(' ')}>
          <div>{props.load.bookingNumber}</div>
        </Col>
      </Row>
    </>
  );
};

export default LoadItem;